const routes = {
  shifts: 'Horário letivo',
  passengers: 'Alunos'
};

export default routes;
